import classNames from 'classnames';
import styled from 'styled-components';
import SearchInput from '../SearchInput';
import { TbPlus } from 'react-icons/tb';
import Button from '../../../../components/Button';
import { useSearchParams } from 'react-router-dom';
import AddMember from '../AddMember';
const tabs = [
  {
    id: 'members',
    title: 'Members'
  },
  {
    id: 'reviewers',
    title: 'Reviewers'
  }
];

export function Filter({
  onChangeTab,
  activeTab,
  onOpenAddApprover,
  searchTerm,
  onChangeSearchTerm
}) {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  return (
    <BoxStyle>
      <div className="tabs">
        {tabs.map(item => (
          <div
            onClick={() => onChangeTab(item.id)}
            className={classNames('tab', activeTab === item.id && 'active')}
            key={item.id}
          >
            {item.title}
          </div>
        ))}
      </div>
      <div className="elements">
        <SearchInput value={searchTerm} onChange={onChangeSearchTerm} />
        {type === 'reviewers' && (
          <Button
            size="sm"
            onClick={onOpenAddApprover}
            variant="outlined"
            leftIcon={<TbPlus fontSize="14px" />}
          >
            Add Approver
          </Button>
        )}
        {(!type || type === 'members') && <AddMember />}
      </div>
    </BoxStyle>
  );
}

const BoxStyle = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #f1f3f5;
  background: #fff;
  margin-top: 20px;
  .elements {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
  }
  .tabs {
    border-radius: 4px;
    background: #f1f3f5;
    display: flex;
    width: fit-content;
    padding: 2px;
    .tab {
      border-radius: 4px;
      padding: 6px 25px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #495057;
      cursor: pointer;
      &.active {
        background: #fff;
        color: #000;
        box-shadow:
          0px 1px 2px 0px rgba(0, 0, 0, 0.1),
          0px 1px 3px 0px rgba(0, 0, 0, 0.05);
      }
    }
  }
`;
